import { Lobby } from "@lobby/core/src/entities";
import { Skeleton } from "shared/ui/skeleton";
import { useMobileBanners } from "../lib/use-banner";
import { BannersListMobile } from "./banners-list.mobile";

export function BannerPanelMobile() {
  const { isPending } = Lobby.useBanner();
  const banners = useMobileBanners();

  const isBannerEmpty = !banners || banners.length === 0;

  return (
    (isPending || !isBannerEmpty) && (
      <div className="[aspect-ratio:2.206] group">
        {isPending && <Skeleton className="bg-silver h-full" />}
        {!isBannerEmpty && <BannersListMobile banners={banners} />}
      </div>
    )
  );
}
